export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'CorporateAccountRequestStatus';
export const NAME = 'CorporateAccountRequestStatus';
